import { z } from "zod";
import { CLAIM_EVIDENCE_CHECK_ID } from "./claim-evidence-check-result.js";
import { DEMO_QUALITY_CHECK_ID } from "./demo-quality-check-result.js";
import { LANGUAGE_HYGIENE_CHECK_ID } from "./language-hygiene-check-result.js";
import { LEAD_PATH_CHECK_ID } from "./lead-path-check-result.js";
export const PHASE1_CHECK_PACK_VERSION = "phase1-quality-checks.v1.0";
export const PHASE1_CHECK_IDS = [
    LANGUAGE_HYGIENE_CHECK_ID,
    LEAD_PATH_CHECK_ID,
    DEMO_QUALITY_CHECK_ID,
    CLAIM_EVIDENCE_CHECK_ID,
];
export const Phase1CheckPackV1Schema = z
    .object({
    schemaVersion: z.literal("phase1-check-pack.v1.0"),
    packVersion: z.literal(PHASE1_CHECK_PACK_VERSION),
    checkIds: z.array(z.string().min(1)).min(1),
})
    .strict();
export function createDefaultPhase1CheckPackV1() {
    return Phase1CheckPackV1Schema.parse({
        schemaVersion: "phase1-check-pack.v1.0",
        packVersion: PHASE1_CHECK_PACK_VERSION,
        checkIds: [...PHASE1_CHECK_IDS],
    });
}
//# sourceMappingURL=phase1-check-pack.js.map